import { useContext } from 'react';

// auth provider
import { Context as AuthContext } from '#root/Context';

const useAuth = () => useContext(AuthContext);

export default useAuth;
